import { HeatmapParams } from './heatmap-params.model';
export class ImageHeatmapConfig {
  modelNameActive: string = '';
  configs = new Map<string, HeatmapParams>();
  timestamp: number = Date.now();
}
